import type {
  AnalyticsInternalData,
  AudioFormInput,
} from './dto/audio-form-input.ts'
import { apiClient } from '../../shared/data/api-client.ts'
import type { BaseDto } from '../../shared/data/audiostack/base.dto.ts'
import type { AudioFormResultResponseDto } from './dto/audio-form-result.dto.ts'
import { mapAudioformInternalData } from '@/utils/map-audioform-internal-data.ts'

export const AudioFormService = {
  createAudioFormVersion: async (
    audioFormInput: AudioFormInput,
    internalData?: AnalyticsInternalData
  ): Promise<string> => {
    const mappedInternalData = mapAudioformInternalData(internalData)
    return await apiClient
      .post<BaseDto<{ audioformId: string }>>(
        '/audioforms',
        {
          audioform: audioFormInput,
        },
        {
          headers: {
            version: 2,
            ...(mappedInternalData
              ? {
                  'x-internal-data': btoa(JSON.stringify(mappedInternalData)),
                }
              : {}),
          },
        }
      )
      .then((response) => response.data.data.audioformId)
  },

  getAudioFormVersion: async (
    audioFormId: string
  ): Promise<AudioFormResultResponseDto> =>
    await apiClient
      .get<AudioFormResultResponseDto>(`/audioforms/${audioFormId}`, {
        headers: {
          version: 2,
        },
      })
      .then((response) => response.data),

  getArrayBuffer: async (url: string): Promise<ArrayBuffer> =>
    await apiClient
      .get<ArrayBuffer>(url, {
        responseType: 'arraybuffer',
      })
      .then((response) => response.data),
}
